import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import paymentReducer, { TEMPLATES_STORAGE_KEY } from './paymentSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    payment: paymentReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Persist payment templates to localStorage on every store change
store.subscribe(() => {
  try {
    localStorage.setItem(
      TEMPLATES_STORAGE_KEY,
      JSON.stringify(store.getState().payment.templates)
    );
  } catch {
    // ignore write errors (e.g. private browsing quota)
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
